import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Alert from "@material-ui/lab/Alert";

import { makeStyles } from "@material-ui/core/styles";

//Material Icons
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import getBrandFromUrl from "../../../utils/getBrandFromUrl";
import { getIdverificationRedirectUrl } from "../../../utils/getIdverificationRedirectUrl";

import * as checkinActions from "src/actions/checkinActions";
import { enableInternationalOcrFlow } from "../../../env";

import { IDVERIFICATION_BASE_URL, IDVERIFICATION_BASE_URL_DEV } from "../../../utils/constants";
import { shouldSkipIdVerification } from "./CheckOcrLabsOutage";
import numeral from "numeral";
import _ from "lodash";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
  },
  paper: {
    backgroundColor: "transparent",
    textAlign: "center",
  },
  iframe: {
    zIndex: 99,
    width: "100vw",
    height: "100vh",
  },
  loadingStatus: { position: "absolute", top: "50%", left: "50%", zIndex: "-1" },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  borderedTile: {
    border: "1px solid rgba(0, 0, 0, .6)",
    backgroundColor: "rgba(255, 204, 0, .1)",
    borderRadius: "5px",
    marginTop: "10px",
  },
}));

const IdVerification = ({ setIdVerified }) => {
  const [iframeLoading, setIframeLoading] = React.useState(true);
  const [redirecting, setRedirecting] = React.useState(false);
  const [isTransactionIDAvailable, setIsTransactionIDAvailable] = React.useState(true);

  const checkin = useSelector((state) => state.checkin);
  const isDemo = useSelector((state) => state.checkin.isDemo);
  const idVerificationStatus = useSelector((state) => state.checkin.idVerification);
  const idVerificationSkipped = useSelector((state) => state.checkin.idVerificationSkipped);
  const isForeignLicence = useSelector((state) => state.checkin.licCountry != "AUSTRALIA");

  const isAdditionalDriver = checkin.isAdditionalDriver ?? false;
  const open = checkin.loading;

  // These fields are to be save into the db for updateReservationAndCustomer
  const resNo = checkin.resNo;
  const currentMainNote = checkin.reservation.ReservationMainNote;
  const customerNumber = checkin.reservation.Renter.customerNumber;
  const brand = getBrandFromUrl();
  const total = numeral(_.get(checkin, "estimate.Estimate.Total", 0)).format("0,0.00");
  const confNo = _.isEmpty(checkin.confNo) ? "--" : checkin.confNo;
  const pickupDate = moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
    "DD-MMM-YY"
  );
  const pickupTime = moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
    "LT"
  );
  const pickupLocation = checkin?.details?.Pickup ? checkin.details.Pickup[0]?.locationName : "";
  const LocationAddress = checkin?.details.Pickup
      ? _.get(checkin, "details.Pickup[0].address1", "") +
      " " +
      _.get(checkin, "details.Pickup[0].address2", "") +
      " " +
      _.get(checkin, "details.Pickup[0].address3", "") +
      " " +
      _.get(checkin, "details.Pickup[0].city", "") +
      " " +
      _.get(checkin, "details.Pickup[0].postCode", "")
      : " ";
  const date = `${moment().format("LLL")} AEST`;
  const otherid = _.get(checkin, "OtherID", "");
  // const country = checkin.country;
  const prepaid = checkin.PrePaid;
  const email = checkin.reservation?.Renter?.Address?.Email
    ? checkin.reservation.Renter.Address.Email
    : checkin.customer?.LatestCustomer?.Address?.Email || "";
  const phoneNumber = checkin.reservation?.Renter?.Address?.HomeTelephoneNumber
    ? checkin.reservation.Renter.Address.HomeTelephoneNumber
    : checkin.customer?.LatestCustomer?.Address?.HomeTelephoneNumber || "";
  const alternatePhone = checkin.reservation?.Renter?.Address?.CellTelephoneNumber
    ? checkin.reservation.Renter.Address.CellTelephoneNumber
    : checkin.customer?.LatestCustomer?.Address?.CellTelephoneNumber || "";

  const estimatecharges = [];
  //   // Day Rate Calculation
  let dayRate = _.find(checkin?.estimate?.Estimate?.Customer?.TimeCharges, function (ratesObject) {
    if (_.includes(ratesObject.Description, "DAYS")) {
      return ratesObject;
    }
  });
  if (dayRate != undefined) {
    estimatecharges.push(dayRate);
  } else {
    dayRate = { Quantity: "0", SubTotal: "0" };
  }
  //Discount Rate
  const discountRate = _.find(checkin?.estimate?.Estimate?.Customer?.TimeCharges, function (
    discountObject
  ) {
    if (_.includes(discountObject.Description, "Discount") && discountObject.SubTotal != 0) {
      return discountObject;
    }
  });
  if (_.has(discountRate, "Discount")) {
    estimatecharges.push(discountRate);
  }
  if (checkin.PrePaid == true) {
    dayRate = { Quantity: "", SubTotal: "Prepaid" };
  }
  // rental Estimates
  const RenterCharges = [];
  _.reduce(
    _.get(checkin, "estimate.Estimate.Customer.OptionsCharges", []),
    function (accumulator, batch) {
      if (_.has(batch, "Quantity")) {
        const { Quantity, SubTotal, Description } = batch;
        if (parseInt(Quantity) != 0 && parseInt(SubTotal) != 0) {
          RenterCharges.push(batch);
          estimatecharges.push(batch);
        }
      }
    },
    0
  );
  const estimate = estimatecharges;

  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const brand = getBrandFromUrl();

  const redirectUrlSuccess = getIdverificationRedirectUrl({
    status: "success",
    isGenericCheckin: checkin.isGenericCheckin,
  });
  const redirectUrlExit = getIdverificationRedirectUrl({
    status: "exit",
    isGenericCheckin: checkin.isGenericCheckin,
  });
  const redirectUrlBack = getIdverificationRedirectUrl({
    status: "back",
    isGenericCheckin: checkin.isGenericCheckin,
  });

  const url = window.location.href;
  const devEnvs = ["staging", "portal", "test", "dev"];

  let isDevEnv;
  for (let i = 0, len = devEnvs.length; i < len; ++i) {
    if (url.indexOf(devEnvs[i]) != -1) {
      isDevEnv = true;
      break;
    }
  }

  const idvBaseUrl = isDevEnv ? IDVERIFICATION_BASE_URL_DEV : IDVERIFICATION_BASE_URL;

  // Piloting phase one, skip idverification for all intl licence:
  React.useEffect(() => {
    if (checkin.licCountry != "AUSTRALIA" && !enableInternationalOcrFlow) {
      setIdVerified(true);
    }
  }, []);

  // React.useEffect(() => {
  //   if (!idVerificationSkipped || checkin.requireReVerifyID) {
  //     requestIdVerification();
  //   }
  // }, []);

  //* Request ID Verification
  const requestIdVerification = () => {
    dispatch(checkinActions.extendSession({ mins: 30 }));
    dispatch(
      checkinActions.requestIdVerificationTransaction({
        isAdditionalDriver,
        token: checkin.auth.token,
        channel: brand + (checkin.licCountry === "NEW ZEALAND" ? " NZ" : (checkin.licCountry !== "AUSTRALIA" ? " Intl" : "")),
        country: checkin.licCountry,
        firstName: checkin.reservation.Renter?.RenterName.firstName,
        lastName: checkin.reservation.Renter?.RenterName.lastName,
        resType: "DS",
        dlNumber: checkin.LicenceNumber,
        reference: isAdditionalDriver ? checkin.resNo : checkin.reservation.ResNo,
        resNumber: isAdditionalDriver ? checkin.resNo : checkin.reservation.ResNo,
        redirectUrlSuccess: redirectUrlSuccess,
        redirectUrlExit: redirectUrlExit,
        redirectUrlBack: redirectUrlBack,
        
        resNo: resNo,
        // MainNote: currentMainNote.slice(0, 30),
        MainNote: currentMainNote,
        CustomerNumber: customerNumber,
        name:
          checkin.reservation.Renter.RenterName.firstName +
          " " +
          checkin.reservation.Renter.RenterName.lastName,
        brand: brand,
        total: total,
        confNo: confNo,
        pickupDate: pickupDate,
        pickupTime: pickupTime,
        pickupLocation: pickupLocation,
        locationAddress: LocationAddress,
        date: date,
        estimate: estimatecharges,
        otherid: otherid,
        // country: country,
        prepaid: prepaid,
        email: email,
        phoneNumber: phoneNumber,
        emergencyPhoneNumber: alternatePhone,
        scanDocPass: true,
        idVerificationSkipped: idVerificationSkipped
      })
    );
  };

  // if ocrlabs service is down, skip idverification
  React.useEffect(() => {
    if (checkin.ocrLabsOutage.length > 0) {
      const shouldSkip = shouldSkipIdVerification(checkin.ocrLabsOutage);
      if (shouldSkip) {
        setIdVerified(true);
        dispatch(checkinActions.idVerificationSkipped({}));
      }
    }
  }, [checkin.ocrLabsOutage]);

  const today = moment().startOf("day");
  const [isDLExpire, setIsDLExpire] = React.useState(!moment(idVerificationStatus.DateOfExpiry, "YYYY-MM-DD").isAfter(today));
  // redirect to id verification page if id is not verify
  React.useEffect(() => {
    let timer = null;
    if (
      idVerificationStatus.TransactionId != undefined &&
      (!idVerificationStatus.Verified || checkin.requireReVerifyID) && 
      idVerificationStatus.Status != "COMPLETED_LEARNER" && 
      !isDLExpire
    ) {
      setRedirecting(true);
      timer = setTimeout(() => {
        location = `${idvBaseUrl}/${idVerificationStatus.TransactionId}`;
        setRedirecting(false);
      }, 5000);
    } else {
      setIsTransactionIDAvailable(false);
    }
    
    return () => {
      clearTimeout(timer);
    };
  }, [idVerificationStatus, isDLExpire]);

  // redirect to id verification page if id is not verify
  React.useEffect(() => {
    if ((!idVerificationSkipped || checkin.requireReVerifyID) && !isTransactionIDAvailable) {
      requestIdVerification();
      setIsDLExpire(false);
    }
  }, [isTransactionIDAvailable]);

  // // redirect to id verification page if id is not verify
  // React.useEffect(() => {
  //   let timer = null;
  //   if (
  //     idVerificationStatus.TransactionId != undefined &&
  //     (!idVerificationStatus.Verified || checkin.requireReVerifyID)
  //   ) {
  //     setRedirecting(true);
  //     timer = setTimeout(() => {
  //       location = `${idvBaseUrl}/${idVerificationStatus.TransactionId}`;
  //       setRedirecting(false);
  //     }, 5000);
  //   }
  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [idVerificationStatus]);

  const skipIDV = () => {
    dispatch(checkinActions.idvSkip());
  };

  //* >>Loading screen for ifream loading..
  const iframeOnLoad = () => {
    setIframeLoading(false);
  };

  return (
    <React.Fragment>
      {/* <div style={{ maxWidth: 600, padding: 20, height: "90vh" }}>
        <div>
          <h4>ID Verification</h4>
          <p>
            Please verify your {isForeignLicence && "passport, foreign"} driver licence details by
            clicking below, the name on the ID needs to match the name on the reservation.
          </p>
        </div>

        <React.Fragment>
          <div>
            <List>
              <ListItem
                className={classes.borderedTile}
                button
                onClick={requestIdVerification}
                disabled={
                  checkin.loading || redirecting || idVerificationStatus.TransactionId != null
                }
              >
                <ListItemAvatar>
                  {idVerificationStatus.Verified &&
                  idVerificationStatus.Status == "COMPLETED_PASS" ? (
                    <CheckCircleOutlineIcon style={{ color: "green" }} />
                  ) : (
                    <ErrorOutlineIcon color="error" />
                  )}
                </ListItemAvatar>
                <ListItemText
                  primary="ID Document Verification"
                  secondary={
                    idVerificationStatus.Verified && idVerificationStatus.Status == "COMPLETED_PASS"
                      ? "Status: Completed. Thanks for verify your ID Document"
                      : idVerificationStatus.Verified &&
                        idVerificationStatus.Status == "COMPLETED_LEARNER"
                      ? "Error. Learner’s permits are inadmissible. Drivers must have a provisional or full driver's licence."
                      : "Status: Pending. Please Verify your ID Document"
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="Validate"
                    onClick={requestIdVerification}
                    disabled={
                      checkin.loading || redirecting || idVerificationStatus.TransactionId != null
                    }
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </List>

            <Alert className={classes.alert} severity="info">
              Please note that we only accept full licences, or probationary licences that have been held for 12+ months.
            </Alert>
            // <Button
              style={{ marginTop: 20, padding: 5, background: 'white' }}
              fullWidth={false}
              onClick={skipIDV}
              title={"PASS IDV"}
              loading={checkin.loading}
            /> //
          </div>
        </React.Fragment>
      </div> */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open || redirecting}
        BackdropComponent={Backdrop}
      >
        <Fade in={open || redirecting}>
          <div className={classes.paper}>
            <React.Fragment>
              <div>{iframeLoading && <CircularProgress />}</div>
              <div>{iframeLoading && <p>Processing, Please wait a moment...</p>}</div>
            </React.Fragment>
          </div>
        </Fade>
      </Modal>

      <Backdrop className={classes.backdrop} open={open && !iframeLoading}>
        <CircularProgress color="primary" />
      </Backdrop>
    </React.Fragment>
  );
};

export default IdVerification;
